<template>
    <table class="table2_default worker no_hover" v-if=isShow>
        <colgroup>
            <col style="width: 200px;">
        </colgroup>
        <thead style="z-index: 99;">
            <tr>
                <th>{{ $t('reservationwindow.reservationmonitor.table_program_program') }}</th>
                <th v-for="(h, index) in parsedHeaders" :key="index">{{ h }}</th>
            </tr>
        </thead>
        <tr v-for="(data, index) in parsedData" :key="index" :class="{'bg_gray no_border': data.programTitle == $t('reservationwindow.reservationmonitor.table_total')}">
            <th class="txt_left"><span v-if="data.color != undefined" class="color_circle" :style="'background-color:' +  data.color + ';'"/>{{ data.programTitle }}</th>
            <td v-for="(v, index) in data.values" :key="index">{{ v[selectedCountType] }}</td>
        </tr>
    </table>
</template>

<script>
import { monitorState } from '../monitor-popup-state'

const moment = require('@/util/MPMoment')

export default {
    name: 'ReservationPerPrograms',
    data() {
        return {
            monitor: monitorState,
        }
    },
    watch: {},
    computed: {
        isShow: function() { return this.monitor.selectedPerType == 'programs' },
        periodType: function() { return this.monitor.selectedPeriod.periodType },
        selectedCountType: function() { return this.monitor.selectedCountType },
        
        // new columns
        targetDateArray: function() {
            return this.monitor.targetDateArray
        },
        loadedProgrmas: function() {
            return this.monitor.loadedPrograms
        },
        selectedPrograms: function() {
            return this.monitor.localPrograms.filter(g => g.isSelected == true)
        },
        currentPrograms: function() {
            return this.monitor.localPrograms.filter(sp => 
                sp.isSelected == true &&
                this.loadedProgrmas.some(lp => lp._id == sp._id)
            )
        },
        parsedHeaders: function() {
            let getWeeksOfMonth = function (date) {
                let startOfMonth = moment(date).startOf('month')
                return Math.ceil((moment(date).date() + startOfMonth.day()) / 7)
            }

            let parsedHeaders = []
            for (let i = 0; i < this.targetDateArray.length; i++) {
                let time = moment(this.targetDateArray[i])
                let value = ''
                if (this.periodType == 'day') {
                    value = time.format(this.$t('reservationwindow.reservationmonitor.label_datedaily'))
                }
                if (this.periodType == 'week') {
                    let date = moment(time).endOf('week')
                    let weeksOfMonth = getWeeksOfMonth(date)
                    const mFormatString = this.$t('reservationwindow.reservationmonitor.table_date_weekly')
                    const wFormatString = this.$t('reservationwindow.reservationmonitor.table_date_weekly_week')
                    value = date.format(mFormatString)
                    value += wFormatString.replace('{n}', weeksOfMonth)
                }
                if (this.periodType == 'month') {
                    value = time.format(this.$t('reservationwindow.reservationmonitor.table_date_monthly'))
                }
                parsedHeaders.push(value)
            }

            return parsedHeaders
        },
        rawData: function() {
            return this.monitor.rawData
        },
        parsedData: function() {
            let programs = this.currentPrograms
            let parsedDatas = []
            for (let i=0 ; i<programs.length ; i++) {
                let parsedData = {}
                let program = programs[i]
                let programID = program._id
                let color = program.color
                parsedData.programTitle = program.title
                parsedData.color = color

                let values = []
                for (let j=0 ; j<this.targetDateArray.length ; j++) {
                    let startDate = this.targetDateArray[j].startOf('days')
                    let endDate = moment(startDate)
                    if (this.periodType === 'day') {
                        endDate = endDate.add(1, 'days')
                    }
                    if (this.periodType === 'week') {
                        endDate = endDate.add(1, 'weeks')
                    }
                    if (this.periodType === 'month') {
                        endDate = endDate.add(1, 'month')
                    }
                    let rawDatas = this.rawData.filter(d => 
                            d.programID._id == programID &&
                            (
                                moment(d.registerDate).isSameOrAfter(startDate) &&
                                moment(d.registerDate).isBefore(endDate)
                            )
                        )
                    let value = {
                        patients: 0,
                        reservations: 0
                    }
                    for (let k=0 ; k<rawDatas.length ; k++) {
                        let raw = rawDatas[k]
                        value.patients += raw.sumHServiceCount
                        value.reservations += raw.sumReservationCount
                    }
                    values.push(value)
                }
                parsedData.values = values
                parsedDatas.push(parsedData)
            }

            // total
            let sums = []
            for (let i=0 ; i<this.targetDateArray.length ; i++) {
                sums.push({patients: 0, reservations: 0})
            }
            for (let i=0 ; i<parsedDatas.length ; i++) {
                let parsedData = parsedDatas[i]
                let values = parsedData.values
                for (let j=0 ; j<values.length ; j++) {
                    sums[j].patients += values[j].patients
                    sums[j].reservations += values[j].reservations
                }
            }
            let parsedData = {
                programTitle: this.$t('reservationwindow.reservationmonitor.table_total'),
                values: sums
            }
            parsedDatas.push(parsedData)

            return parsedDatas
        }
    }
}
</script>


<style scoped>
.width_90 { width: 90px; }
.width_77 { width: 77px; }
</style>